import { equal } from '@sitecore-search/common';
import WidgetRequest from './WidgetSearchRequest.js';
export default class SearchResultsWidgetRequest extends WidgetRequest {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "facetTypeFiltersType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'or'
        });
    }
    buildFacetTypeFilters(values, type = 'or') {
        if (values.length === 0) {
            return undefined;
        }
        return {
            type,
            values,
        };
    }
    setSearchFacetTypeFilterType(type) {
        this.facetTypeFiltersType = type;
        return this;
    }
    getSearchFacetTypeFilterType() {
        return this.facetTypeFiltersType;
    }
    setSearchFacetType(name, facetType) {
        const prevFacetTypes = this.getSearchFacetTypes() || [];
        if (!prevFacetTypes.find(({ name: filterTypeName }) => filterTypeName === name)) {
            this.setSearchFacetTypes([...prevFacetTypes, { ...facetType, name }]);
            return this;
        }
        this.setSearchFacetTypes(prevFacetTypes.map((prevFacetType) => {
            if (prevFacetType.name === name) {
                return { ...facetType, name };
            }
            return prevFacetType;
        }));
        return this;
    }
    /**
     * @TODO:
     * when a facet does not have any values, it is keeping the facet name
     * e.g.:
     * {name: "colors"}
     * without filter or values.
     */
    updateSearchFacetType(name, facetType) {
        const prevFacetTypes = this.getSearchFacetTypes() || [];
        this.setSearchFacetType(name, {
            ...prevFacetTypes.find(({ name: filterTypeName }) => filterTypeName === name),
            ...facetType,
        });
        return this;
    }
    addSearchFacetTypeFilter(name, value, type = 'or') {
        const prevFacetTypes = this.getSearchFacetTypes() || [];
        const prevFilterTypeValues = prevFacetTypes.find(({ name: filterTypeName }) => filterTypeName === name)?.filter?.values || [];
        this.updateSearchFacetType(name, { filter: this.buildFacetTypeFilters([...prevFilterTypeValues, value], type) });
        return this;
    }
    resetSearchFacetTypeFilter(name) {
        this.updateSearchFacetType(name, {
            filter: undefined,
        });
        return this;
    }
    removeSearchFacetTypeFilter(name, value) {
        const prevFacetTypes = this.getSearchFacetTypes() || [];
        const prevFilterTypeValues = prevFacetTypes.find(({ name: filterTypeName }) => filterTypeName === name)?.filter?.values || [];
        this.updateSearchFacetType(name, {
            filter: this.buildFacetTypeFilters(prevFilterTypeValues.filter((val) => !equal(val, value))),
        });
        return this;
    }
    resetSearchFacetTypeFilters() {
        const facetTypes = this.getSearchFacetTypes() || [];
        facetTypes.forEach(({ name }) => {
            this.updateSearchFacetType(name, { filter: undefined });
        });
        return this;
    }
}
